import {useAllSegments} from '@/hooks/useSegmentsByGroupId'
import {useState} from 'react'

export const useSegmentModalList = (selectedSegments, setSelectedSegments) => {
  const [currentPage, setCurrentPage] = useState(0)
  const [searchTerm, setSearchTerm] = useState('')
  const {data, isFetching} = useAllSegments(currentPage, 10, searchTerm)

  const handleSearch = term => {
    setCurrentPage(0) // Reset to first page on new search
    setSearchTerm(term)
  }

  const items = data?.data?.map(segment => ({
    id: segment.segmentId,
    label: segment.segmentName ?? segment.segmentId,
    checked: selectedSegments.find(selected => selected.segmentId === segment.segmentId),
    selected: false,
  }))

  const handleSegmentCheckboxChange = (segment, checked) => {
    setSelectedSegments(prevSelected => {
      if (checked) {
        return [...prevSelected, {segmentId: segment.id, segmentName: segment.label}]
      } else {
        return prevSelected.filter(selected => selected.segmentId !== segment.id)
      }
    })
  }

  return {
    setCurrentPage,
    setSearchTerm,
    items,
    currentPage,
    isFetching,
    totalPages: data?.totalPages || 0,
    handleSearch,
    handleSegmentCheckboxChange,
  }
}
